<template>
  <field-text
    ref="tmFieldRef"
    :model-value="modelValue"
    :left-icon="withIcon ? 'search' : undefined"
    class="tm-search"
    clearable
    native-type="search"
    :size="size"
    :debounce="debounce"
    :loading="loading"
    :max="maxLength"
    :no-append-padding="noAppendPadding"
    :is-disabled="isDisabled"
    @update:model-value="change"
  >
    <template v-slot:append>
      <slot name="append" />
    </template>
  </field-text>
</template>

<script lang="ts">
import { defineComponent, ref } from '@/composition/vue/compositionApi'
import type { FieldTextSize } from '@/components/forms/fields/FieldText.vue'
import FieldText from '@/components/forms/fields/FieldText.vue'
import type { SizeProp } from '@/components/shared/types'
import { DefaultInputEvent } from '@/services/forms/types'

export default defineComponent({
  components: {
    FieldText,
  },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    size: {
      type: String as SizeProp<FieldTextSize>,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    debounce: {
      type: Number,
    },
    withIcon: {
      type: Boolean,
      default: true,
    },
    maxLength: {
      type: Number,
    },
    noAppendPadding: {
      type: Boolean,
    },
    isDisabled: {
      type: Boolean,
    },
  },
  emits: {
    [DefaultInputEvent]: (_val: string) => true,
  },
  setup(_props, context) {
    const tmFieldRef = ref()

    const change = (v: string) => context.emit(DefaultInputEvent, v)

    const focus = () => {
      tmFieldRef.value.focus()
    }

    const blur = () => {
      tmFieldRef.value.blur()
    }

    return {
      tmFieldRef,
      change,
      focus,
      blur,
    }
  },
})
</script>

<style lang="scss" scoped>
.tm-search {
  :deep(.q-field__control) {
    // clear button
    .q-field__append {
      margin-right: 11px;
      button {
        font-size: 16px;
        color: $gray;
        transition: all $transition-300ms-ease-in-out;
        opacity: 1;
      }
    }
  }
}
</style>
